import { ColumnDef } from '@tanstack/react-table'
import { Button } from 'components/ui/button'
import { Check, Mail, MapPin, Phone, X } from 'lucide-react'
import type { ClubManagerRow } from 'store/clubManagers/clubManagersSlice'

export interface ClubManagersColumnsProps {
  onApprove: (clubManagerProfileId: number, notes: string) => void
  onReject: (clubManagerProfileId: number, notes: string) => void
}

export const clubManagersColumns = (
  props: ClubManagersColumnsProps
): ColumnDef<ClubManagerRow>[] => [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: (info) => (
      <div className='text-center'>{String(info.getValue())}</div>
    ),
  },
  {
    accessorFn: (row) => `${row.first_name} ${row.last_name}`,
    header: 'Utente',
    cell: (info) => (
      <div>
        <strong>{String(info.getValue())}</strong>
        <br />
        <div className='flex flex-row gap-2'>
          <Mail className='inline-block' /> {info.row.original.email || '-'}
        </div>
        <br />
        <div className='flex flex-row gap-2'>
          <Phone className='inline-block' /> {info.row.original.phone || '-'}
        </div>
      </div>
    ),
  },
  {
    accessorFn: (row) => row.club.name,
    header: 'Circolo',
    cell: (info) => (
      <div>
        <strong>{String(info.getValue())}</strong>
        <br />
        <div className='flex flex-row gap-2'>
          <Phone className='inline-block' />{' '}
          {info.row.original.club.phone || '-'}
        </div>
        <br />
        <div className='flex flex-row gap-2'>
          <MapPin className='inline-block' />{' '}
          {info.row.original.club.legal_address || '-'}
        </div>
      </div>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Stato',
    cell: ({ row }) => {
      const { status, notes, id } = row.original
      return (
        <div>
          {!status && (
            <div className='uk-alert uk-alert-warning uk-text-center'>
              In attesa di verifica.
            </div>
          )}
          {notes && <p className='uk-text-center'>Motivazione: {notes}</p>}
          <div className='flex justify-between gap-3'>
            <Button
              size='sm'
              variant='outline'
              disabled={status === 'approved'}
              onClick={() => {
                const notes = prompt('Motivazioni')
                if (notes && notes !== '') {
                  props.onApprove(id, notes)
                }
              }}
            >
              <Check />
              Approva
            </Button>
            <Button
              size='sm'
              variant='destructive'
              disabled={status === 'rejected'}
              onClick={() => {
                const notes = prompt('Motivazioni')
                if (notes && notes !== '') {
                  props.onReject(id, notes)
                }
              }}
            >
              <X />
              Rifiuta
            </Button>
          </div>
        </div>
      )
    },
  },
]
